import { useParams, Navigate, useLocation } from 'react-router-dom';
import { pageRoutes } from './dictionary';
import { collegeMap } from './collegeMap';
import { majorMap } from './majorMap';
import { extracurricularMap } from './extracurricularMap';

export const RedirectToDetail = ({ page }: { page: string }) => {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  const query = location.search || '';
  let matchingObject: any;

  switch (page) {
    case 'colleges':
      matchingObject = collegeMap.find((c) => String(c.id) === id);
      break;
    case 'majors':
      matchingObject = majorMap.find((c) => String(c.id) === id);
      break;
    case 'extracurriculars':
      matchingObject = extracurricularMap.find((c) => String(c.id) === id);
      break;
    default:
      return <Navigate to={pageRoutes.home} replace />;
  }

  if (!matchingObject) {
    return <Navigate to={pageRoutes.home} replace />;
  }

  return <Navigate to={`/${matchingObject.hyphenated}${query}`} replace />;
};